module.exports = "<p>\r\n  logout works!\r\n</p>\r\n"